import { UsercryptApi } from '@calm/evexia-web-sdk/generated/lib/api/usercrypt-api';
import { AxiosInstance } from 'axios';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of a `UsercryptApi`
 * @param accessToken
 * @returns
 */
export default function createUsercryptApi(
    accessToken: () => Promise<string>,
    client?: AxiosInstance
) {
    return createApi(UsercryptApi, accessToken, undefined, client);
}
